<template lang="pug">
v-btn.botao-ver-loja(
  v-if="url",
  depressed,
  color="white",
  :href="url",
  target="_blank",
  rel="noopener",
  title="Veja sua loja do jeito que o cliente vê",
  @click="registrarClique"
)
  v-icon(left, size="18", color="#17603a") storefront
  | Ver loja
  v-icon(right, size="15", color="#17603a") open_in_new
</template>

<script>

export default {
  name: 'BotaoVerLoja',
  props: {
    estabelecimento: { type: Object, default: null },
    origem: { type: String, required: true },
  },
  computed: {
    isCardapioDigital() {
      return !!(this.estabelecimento && this.estabelecimento.cardapio_digital);
    },
    url() {
      const estabelecimento = this.estabelecimento;
      if (!estabelecimento || !estabelecimento.id) return '';
      const temDados = this.isCardapioDigital
        ? !!estabelecimento.uid
        : !!(estabelecimento.localidade && estabelecimento.estado);
      return temDados ? this.$root.getURL(estabelecimento) : '';
    },
  },
  methods: {
    registrarClique() {
      if (!this.$firebase || !this.$firebase.logEvent) return;
      this.$firebase.logEvent('view_store_clicked', {
        establishment_id: this.estabelecimento.id,
        store_type: this.isCardapioDigital ? 'cardapio_digital' : 'marketplace',
        origem: this.origem,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.botao-ver-loja {
  margin: 0;
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  color: #17603a !important;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15) !important;
}
</style>
